<template>
    <div class="app-footer">
        <div class="lf">
            <a class="link" target="_blank" href="http://beian.miit.gov.cn/">浙ICP备17056291号-2</a>
            <a class="link" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002015416"><i class="ic-police"></i> 浙公网安备33011002015416号</a>
        </div>
        <div class="rt">
            <span class="text">© 2017-2021 浙江省服装产业创新服务综合体 版权所有</span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.app-footer {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    background: #232628;
    .lf {
        display: flex;
        align-items: center;
        font-size: 0;
    }
    .ic-police {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url(../../assets/icon_police_badge.png) no-repeat center/14px 14px;
        vertical-align: middle;
        margin-right: 4px;
    }
    .link {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 20px;
        margin-right: 24px;
        text-decoration: none;
        &:hover {
            color: rgba(255, 255, 255, 0.8); 
        }
    }
    .text {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 20px;
    }
}
</style>